import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import IdentifyFrontendCode from "./identify-frontend-code.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Linking events to specific users enables you to build a full picture of how they're using your product across different sessions, devices, and platforms. `}</p>
    <p>{`This is straightforward to do when `}<a parentName="p" {...{
        "href": "/docs/product-analytics/capture-events?tab=Node.js"
      }}>{`capturing backend events`}</a>{`, as you associate events to a specific user using `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`, which is a required argument. However, on the `}<a parentName="p" {...{
        "href": "/docs/getting-started/send-events#sending-custom-properties-on-an-event"
      }}>{`frontend`}</a>{`, a `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` is not a required argument and events can be submitted anonymously. `}</p>
    <p>{`To link events from anonymous to specific users, capture events with person profiles by calling `}<inlineCode parentName="p">{`identify`}</inlineCode>{`:`}</p>

    <IdentifyFrontendCode mdxType="IdentifyFrontendCode" />
    <p>{`This creates a person profile if one doesn't exist already.`}</p>
    <p>{`Under our current `}<a parentName="p" {...{
        "href": "/pricing"
      }}>{`pricing`}</a>{`, events `}<em parentName="p">{`without`}</em>{` person profiles can be up to 4x cheaper than events `}<em parentName="p">{`with`}</em>{` them (due to the cost of processing them), so it's recommended to only capture events with person profiles when needed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      